"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShutterstockFolder = exports.getImageRows = exports.getAcquireStatus = exports.getSearchStatus = exports.getTotal = exports.getResultsCount = exports.getResults = void 0;

var _reselect = require("reselect");

var _immutable = _interopRequireDefault(require("immutable"));

var _partition = require("FileManagerCore/utils/partition");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _Folders = require("FileManagerCore/selectors/Folders");

var _Constants = require("FileManagerCore/Constants");

var _UserSettings = require("FileManagerCore/selectors/UserSettings");

var SIZE = 200;
var BANNER_HEIGHT = 20;

var getShutterstockFolderId = function getShutterstockFolderId(state) {
  var userSettings = (0, _UserSettings.getUserSettings)(state);
  return userSettings.get('shutterstockFolderId');
};

var partitionImages = function partitionImages(images, viewWidth) {
  if (!viewWidth) {
    return new _immutable.default.List();
  }

  var imagesWithScaling = images.map(function (image) {
    var width = image.get('smallPreviewWidth');
    var height = image.get('smallPreviewHeight');
    var aspectRatio = image.get('smallPreviewWidth') / image.get('smallPreviewHeight');
    var scale = Math.min(1, SIZE / height);
    var bannerOffset = scale * BANNER_HEIGHT;
    return image.merge({
      scaledWidth: width * scale,
      scaledHeight: height * scale,
      aspectRatio: aspectRatio,
      bannerOffset: bannerOffset
    });
  });
  var aspectRatios = imagesWithScaling.map(function (image) {
    return image.get('aspectRatio');
  }).toArray();
  var totalWidth = imagesWithScaling.reduce(function (acc, image) {
    return acc + image.get('scaledWidth');
  }, 0);
  var numRows = Math.ceil(totalWidth / viewWidth);

  if (numRows === 1) {
    return new _immutable.default.List().push(imagesWithScaling);
  }

  var rows = (0, _partition.partition)(aspectRatios, numRows);
  var result = new _immutable.default.List();
  rows.forEach(function (row) {
    var nextRow = new _immutable.default.List();
    row.forEach(function (aspectRatio) {
      var index = imagesWithScaling.findIndex(function (image) {
        return image.get('aspectRatio') === aspectRatio;
      });
      var image = imagesWithScaling.get(index);
      imagesWithScaling = imagesWithScaling.delete(index);
      nextRow = nextRow.push(image);
    });
    result = result.push(nextRow);
  });
  return result;
};

var getResults = function getResults(state) {
  return state.shutterstock.get('results');
};

exports.getResults = getResults;

var getResultsCount = function getResultsCount(state) {
  return getResults(state).count();
};

exports.getResultsCount = getResultsCount;

var getTotal = function getTotal(state) {
  return state.shutterstock.get('total');
};

exports.getTotal = getTotal;

var getSearchStatus = function getSearchStatus(state) {
  return state.shutterstock.get('searchStatus');
};

exports.getSearchStatus = getSearchStatus;

var getAcquireStatus = function getAcquireStatus(state) {
  return state.shutterstock.get('acquireStatus');
};

exports.getAcquireStatus = getAcquireStatus;

var getWidth = function getWidth(state, props) {
  return props.width;
};

var findShutterstockFolder = function findShutterstockFolder(folders, shutterstockFolderId) {
  var shutterstockFolder;

  if (shutterstockFolderId) {
    shutterstockFolder = folders.find(function (folder) {
      return folder.get('id') === shutterstockFolderId;
    });
  } else if (shutterstockFolderId === null) {
    shutterstockFolder = (0, _FoldersAndFiles.getHomeFolder)();
  }

  if (!shutterstockFolder) {
    shutterstockFolder = folders.find(function (folder) {
      return folder.get('folder_path') === _Constants.ShutterstockFolderPath;
    });
  }

  return shutterstockFolder;
};

var getImageRows = (0, _reselect.createSelector)([getResults, getWidth], partitionImages);
exports.getImageRows = getImageRows;
var getShutterstockFolder = (0, _reselect.createSelector)([_Folders.getFolders, getShutterstockFolderId], findShutterstockFolder);
exports.getShutterstockFolder = getShutterstockFolder;